var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 670,
    viewBox: "0 0 400 670",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.628 416.967L379.321 466.979C376.14 477.379 367.278 484.383 357.304 484.383H270.703C260.729 484.383 251.868 477.379 248.683 466.979L236.096 425.844C233.901 418.675 238.749 411.25 245.625 411.25H255.32C259.888 411.25 263.759 407.559 264.396 402.573L270.056 358.45C271.405 347.915 279.599 340.081 289.268 340.081H367.251C379.036 340.081 388.102 351.547 386.465 364.391L381.615 402.457C381.024 407.104 384.302 411.25 388.567 411.25H390.907C393.587 411.25 395.487 414.159 394.628 416.967Z",
    fill: "#4849FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.004 483.039H307.311V577.4H320.004V483.039Z",
    fill: "white",
    stroke: "#4849FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.268 589.961V585.585C348.268 581.065 343.07 577.398 336.66 577.398H291.421C285.023 577.398 279.812 581.065 279.812 585.585V589.961",
    stroke: "#4849FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.055 607.768C284.972 607.768 288.958 603.782 288.958 598.865C288.958 593.947 284.972 589.961 280.055 589.961C275.137 589.961 271.151 593.947 271.151 598.865C271.151 603.782 275.137 607.768 280.055 607.768Z",
    fill: "white",
    stroke: "#E3B03D",
    strokeWidth: 7.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.108 607.768C353.025 607.768 357.011 603.782 357.011 598.865C357.011 593.947 353.025 589.961 348.108 589.961C343.191 589.961 339.204 593.947 339.204 598.865C339.204 603.782 343.191 607.768 348.108 607.768Z",
    fill: "white",
    stroke: "#6869E1",
    strokeWidth: 7.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.092 563.631C200.952 567.908 196.816 582.534 198.3 587.78C199.783 593.027 203.942 596.886 202.796 602.236C201.565 607.933 168.154 604.33 167.128 604.102C166.102 603.873 184.873 593.451 185.092 585.696C185.311 577.942 182.838 563.631 182.838 563.631H202.092Z",
    fill: "#D28E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.783 608.187H203.086C204.069 608.187 204.865 607.39 204.865 606.408V606.405C204.865 605.423 204.069 604.626 203.086 604.626H161.783C160.8 604.626 160.003 605.423 160.003 606.405V606.408C160.003 607.39 160.8 608.187 161.783 608.187Z",
    fill: "#94BCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.362 604.855C191.362 604.855 187.021 599.564 180.906 598.008C174.203 596.303 170.952 597.211 167.337 599.039C163.835 600.809 161.876 604.628 161.876 604.628L191.362 604.855Z",
    fill: "#CFE0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51 604.773C191.51 604.773 191.141 592.373 199.34 590.761C199.34 590.761 207.215 597.789 202.86 604.773H191.51Z",
    fill: "#CFE0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.092 563.631H182.84C182.84 563.631 183.315 566.382 183.825 570.123C190.828 570.783 198.026 568.459 201.095 567.298C201.501 565.767 201.846 564.49 202.092 563.631Z",
    fill: "#C97C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.409 479.412C236.773 479.395 225.869 479.306 211.48 479.089C213.244 491.478 215.08 506.871 214.8 519.496C214.534 531.392 212.093 532.997 212.191 538.007C212.358 546.062 206.991 548.732 208.726 554.496C211.645 564.143 202.082 563.638 202.082 563.638C202.082 563.638 189.563 565.944 180.072 563.638L170.376 463.969C167.588 454.706 179.821 443.543 191.901 438.129C212.698 428.814 291.608 393.202 301.947 425.755C304.688 434.415 295.863 479.495 247.409 479.412Z",
    fill: "#C5D7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.742 563.631C259.602 567.908 255.468 582.534 256.95 587.78C258.431 593.027 262.592 596.886 261.448 602.236C260.218 607.933 226.806 604.33 225.78 604.102C224.754 603.873 243.523 593.451 243.745 585.696C243.966 577.942 241.493 563.631 241.493 563.631H260.742Z",
    fill: "#D28E46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.445 608.187H261.748C262.731 608.187 263.527 607.39 263.527 606.408V606.405C263.527 605.423 262.731 604.626 261.748 604.626H220.445C219.462 604.626 218.666 605.423 218.666 606.405V606.408C218.666 607.39 219.462 608.187 220.445 608.187Z",
    fill: "#94BCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.025 604.855C250.025 604.855 245.681 599.564 239.566 598.008C232.865 596.303 229.612 597.211 225.997 599.039C222.495 600.809 220.536 604.628 220.536 604.628L250.025 604.855Z",
    fill: "#CFE0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.172 604.773C250.172 604.773 249.801 592.373 258 590.761C258 590.761 265.875 597.789 261.519 604.773H250.172Z",
    fill: "#CFE0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.742 563.631H241.5C241.5 563.631 241.978 566.382 242.485 570.123C249.491 570.783 256.689 568.459 259.757 567.298C260.168 565.767 260.513 564.49 260.742 563.631Z",
    fill: "#C97C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.782 479.412C288.146 479.394 277.242 479.306 262.853 479.089C264.618 491.478 266.453 506.871 266.173 519.496C265.907 531.392 267.103 532.997 267.209 538.007C267.376 546.062 265.651 548.732 267.386 554.496C270.305 564.143 260.742 563.638 260.742 563.638C260.742 563.638 248.223 565.944 238.732 563.638L221.752 463.969C218.966 454.706 223.91 443.543 235.99 438.129C256.79 428.814 333.101 385.174 345.671 434.135C347.918 442.925 347.239 479.495 298.782 479.412Z",
    fill: "#CFE0F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.72 306.445C270.041 314.716 276.383 319.173 253.118 376.489C244.293 398.234 226.408 387.859 227.724 376.698C229.041 365.538 243.673 321.875 248.698 311.706C254.147 300.676 267.62 299.554 268.72 306.445Z",
    fill: "#D1E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.832 385.801C227.99 394.201 162.358 389.338 162.169 385.12C161.95 380.198 220.113 369.148 232.496 367.794C247.268 366.18 254.872 380.796 244.832 385.801Z",
    fill: "#F4DABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.76 382.398C173.339 380.887 161.632 381.091 157.791 382.152C153.95 383.212 148.686 387.669 147.948 388.651C147.209 389.633 145.487 394.757 145.487 394.757C145.487 394.757 146.993 396.662 149.156 393.735C151.319 390.809 156.821 387.711 158.148 388.599C161.128 390.595 154.265 392.087 153.435 393.275C152.606 394.464 152.965 395.244 152.965 395.244C152.965 395.244 160.082 393.824 161.187 393.748C162.292 393.672 166.033 392.133 168.225 390.359C170.418 388.585 174.38 384.625 173.76 382.398Z",
    fill: "#E38E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.869 442.227C355.451 454.667 332.961 398.557 328.736 384.394C326.737 377.695 331.298 351.732 336.163 330.587C341.084 309.145 333.34 301.442 320.027 298.122C305.178 294.416 285.978 295.39 281.443 295.993C267.103 297.893 263.633 299.584 257.031 303.13C253.75 304.892 253.923 339.06 252.963 348.053C252.003 357.045 256.758 362.494 262.366 366.202C263.968 367.263 267.33 372.879 267.251 386.136C267.172 399.393 265.248 406.518 259.922 413.975C259.922 413.975 314.736 406.828 344.869 442.227Z",
    fill: "#E7F0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.04 297.492L282.137 337.591L267.172 298.196",
    stroke: "white",
    strokeWidth: 8.88,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.422 304.09C338.574 309.785 346.422 321.39 363.471 380.852C369.936 403.41 355.178 402.755 349.331 393.157C343.484 383.559 318.794 339.87 316.39 328.786C312.206 309.487 327.301 299.34 332.422 304.09Z",
    fill: "#D1E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.528 399.285C343.056 408.076 271.653 398.667 271.444 394.287C271.198 389.166 332.356 384.519 345.216 383.062C360.552 381.327 370.94 394.055 360.528 399.285Z",
    fill: "#F4DABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.172 395.16C281.261 396.728 270.11 400.301 266.129 400.523C262.147 400.744 255.731 398.227 254.713 397.538C253.694 396.849 250.409 392.549 250.409 392.549C250.409 392.549 251.223 390.263 254.211 392.338C257.198 394.412 263.407 395.576 264.377 394.307C266.554 391.457 259.58 392.254 258.409 391.393C257.238 390.531 257.333 389.67 257.333 389.67C257.333 389.67 264.527 388.725 265.597 388.44C266.668 388.154 270.703 388.412 273.351 389.385C275.999 390.357 281.044 392.852 281.172 395.16Z",
    fill: "#E38E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.462 267.222C307.294 266.073 315.105 255.313 312.427 246.09C309.75 236.866 296.658 226.003 283.266 230.317C269.874 234.631 261.657 241.067 263.249 254.275C264.514 264.776 297.379 299.065 320.027 297.763C329.132 297.241 338.316 278.095 326.425 270.953C314.534 263.811 301.462 267.222 301.462 267.222Z",
    fill: "#E5B21A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.794 270.953C319.766 259.92 301.796 266.887 301.796 266.887",
    stroke: "#E5B21A",
    strokeWidth: 5.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.626 266.085C299.626 266.085 297.714 287.835 309.157 296.335L284.708 324.809L274.053 297.421C274.053 297.421 285.988 295.206 281.064 266.085H299.626Z",
    fill: "#F4DABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.508 270.293C299.469 270.687 299.442 270.923 299.442 270.923C299.442 274.925 291.289 290.259 279.983 291.534C282.033 287.104 283.318 279.421 281.061 266.073H299.626C299.626 266.073 299.481 267.724 299.508 270.293Z",
    fill: "#EDBF90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.478 267.887C299.456 268.108 299.441 268.233 299.441 268.233C299.788 271.216 287.875 283.135 278.47 284.23C274.247 284.722 267.964 272.53 266.931 268.401C265.425 262.381 265.341 256.443 265.265 254.282C265.142 250.78 265.363 242.009 275.453 242.009C285.606 242.009 291.316 264.367 298.802 259.849C298.939 259.539 300.222 256.911 303.477 258.99C305.879 260.531 302.249 266.213 299.478 267.887Z",
    fill: "#F4DABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.062 259.92L274.053 267.835L276.031 270.21",
    stroke: "#40465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.283 268.342C270.695 268.342 273.462 265.575 273.462 262.162C273.462 258.749 270.695 255.983 267.283 255.983C263.87 255.983 261.104 258.749 261.104 262.162C261.104 265.575 263.87 268.342 267.283 268.342Z",
    stroke: "#3268E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.763 268.342C287.176 268.342 289.943 265.575 289.943 262.162C289.943 258.749 287.176 255.983 283.763 255.983C280.351 255.983 277.584 258.749 277.584 262.162C277.584 265.575 280.351 268.342 283.763 268.342Z",
    stroke: "#3268E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.462 262.162H277.584",
    stroke: "#3268E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.945 261.825C289.945 261.825 299.882 255.697 304.147 258.985",
    stroke: "#3268E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.761 263.602C270.578 263.602 271.24 262.94 271.24 262.123C271.24 261.306 270.578 260.644 269.761 260.644C268.944 260.644 268.282 261.306 268.282 262.123C268.282 262.94 268.944 263.602 269.761 263.602Z",
    fill: "#40465C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.514 263.602C282.331 263.602 282.993 262.94 282.993 262.123C282.993 261.306 282.331 260.644 281.514 260.644C280.697 260.644 280.035 261.306 280.035 262.123C280.035 262.94 280.697 263.602 281.514 263.602Z",
    fill: "#40465C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.203 274.664C276.203 274.664 279.513 275.262 281.787 272.117",
    stroke: "#40465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.665 363.734H133.566C131.799 363.733 130.076 363.185 128.633 362.165C127.19 361.145 126.099 359.703 125.509 358.037L103.423 295.654C103.106 294.759 103.008 293.801 103.138 292.861C103.268 291.92 103.622 291.025 104.17 290.25C104.718 289.474 105.443 288.842 106.286 288.406C107.129 287.969 108.065 287.741 109.014 287.742H217.999C219.507 287.741 220.979 288.209 222.211 289.08C223.443 289.951 224.374 291.182 224.877 292.604L247.271 355.819C247.588 356.715 247.686 357.675 247.555 358.616C247.424 359.558 247.069 360.454 246.52 361.23C245.97 362.006 245.243 362.638 244.398 363.074C243.553 363.51 242.616 363.736 241.665 363.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.304 367.096H130.202C128.435 367.096 126.712 366.548 125.269 365.528C123.826 364.508 122.735 363.067 122.145 361.401L100.059 299.018C99.7416 298.123 99.6436 297.165 99.7736 296.224C99.9046 295.283 100.258 294.388 100.807 293.612C101.355 292.837 102.081 292.204 102.924 291.767C103.767 291.331 104.703 291.103 105.653 291.103H214.642C216.153 291.102 217.626 291.569 218.86 292.44C220.094 293.311 221.028 294.543 221.533 295.966L243.912 359.184C244.229 360.08 244.327 361.039 244.196 361.981C244.065 362.922 243.71 363.819 243.16 364.595C242.61 365.37 241.882 366.002 241.037 366.438C240.192 366.873 239.254 367.098 238.304 367.096Z",
    fill: "#E7F0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.665 363.397H133.566C131.799 363.397 130.076 362.849 128.633 361.829C127.19 360.81 126.099 359.368 125.509 357.702L103.423 295.319C103.106 294.424 103.008 293.466 103.138 292.526C103.268 291.585 103.622 290.69 104.17 289.914C104.718 289.139 105.443 288.506 106.286 288.07C107.129 287.633 108.065 287.405 109.014 287.404H217.999C219.507 287.405 220.979 287.872 222.21 288.743C223.442 289.614 224.374 290.845 224.877 292.267L247.271 355.482C247.588 356.378 247.686 357.338 247.555 358.279C247.424 359.221 247.069 360.117 246.52 360.893C245.97 361.669 245.243 362.301 244.398 362.737C243.553 363.173 242.616 363.399 241.665 363.397Z",
    stroke: "#96BED5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.277 380.636H153.143L163.23 337.926H195.366L185.277 380.636Z",
    fill: "white",
    stroke: "#96BED5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.262 265.022C196.643 265.022 198.976 261.722 198.976 258.252V238.827C198.977 237.931 198.8 237.043 198.457 236.214C198.114 235.386 197.612 234.633 196.978 233.999C196.344 233.364 195.591 232.861 194.763 232.518C193.934 232.175 193.046 231.998 192.15 231.998H147.953C147.056 231.998 146.167 232.174 145.339 232.517C144.51 232.86 143.757 233.363 143.123 233.998C142.489 234.632 141.986 235.385 141.643 236.214C141.3 237.042 141.123 237.93 141.124 238.827V258.252C141.124 259.149 141.3 260.036 141.643 260.865C141.987 261.693 142.49 262.446 143.124 263.08C143.758 263.714 144.511 264.217 145.339 264.56C146.168 264.903 147.056 265.079 147.953 265.079H173.866C180.21 265.079 183.628 275.284 183.628 275.284C183.628 275.284 185.788 265.022 193.262 265.022Z",
    fill: "white",
    stroke: "#6869E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.41 250.918C158.818 250.918 159.959 249.777 159.959 248.369C159.959 246.96 158.818 245.819 157.41 245.819C156.002 245.819 154.86 246.96 154.86 248.369C154.86 249.777 156.002 250.918 157.41 250.918Z",
    fill: "white",
    stroke: "#6869E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.049 251.085C171.457 251.085 172.598 249.944 172.598 248.536C172.598 247.128 171.457 245.986 170.049 245.986C168.641 245.986 167.499 247.128 167.499 248.536C167.499 249.944 168.641 251.085 170.049 251.085Z",
    fill: "white",
    stroke: "#6869E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.685 251.085C184.093 251.085 185.235 249.944 185.235 248.536C185.235 247.128 184.093 245.986 182.685 245.986C181.277 245.986 180.136 247.128 180.136 248.536C180.136 249.944 181.277 251.085 182.685 251.085Z",
    fill: "white",
    stroke: "#6869E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4092 605.246V383.338H309.105V625.14",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4092 605.246V383.338H309.105V625.14",
    stroke: "#4849FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.94 169.716H269.409V185.466H350.94V169.716Z",
    fill: "white",
    stroke: "#6869E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.519 162.569H282.173V168.736H364.519V162.569Z",
    fill: "#4849FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.834 153.446H274.488V161.533H356.834V153.446Z",
    fill: "white",
    stroke: "#96BED5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.189 143.199H269.549V152.388H342.189V143.199Z",
    fill: "#E7F0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78 198.743H211.586L181.408 154.798H40.5771V143.219H187.354L217.531 187.162H364.78V198.743Z",
    fill: "white",
    stroke: "#96BED5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.608 162.249H256.307V165.567C256.307 171.096 254.111 176.399 250.201 180.309C246.291 184.219 240.988 186.416 235.459 186.416C229.929 186.416 224.626 184.219 220.717 180.309C216.807 176.399 214.61 171.096 214.61 165.567V162.249H214.608Z",
    fill: "#D1E2FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22 162.249C221.22 162.249 212.181 169.615 207.026 163.576C203.29 159.2 218.082 159.195 218.082 159.195C218.082 159.195 210.282 152.949 212.755 151.812C218.833 149.049 222.401 158.341 222.401 158.341C222.401 158.341 214.034 142.707 221.284 140.019C227.244 137.805 227.244 153.919 227.244 153.919C227.244 153.919 228.507 147.39 231.878 147.811C235.25 148.232 232.826 155.194 232.826 155.194C232.826 155.194 235.779 153.193 235.983 157.721C235.983 157.721 236.554 140.494 243.777 142.136C249.779 143.504 241.776 155.3 241.776 155.3C241.776 155.3 246.41 149.506 250.514 151.298C254.619 153.09 246.823 158.457 246.823 158.457C246.823 158.457 257.983 148.032 262.026 150.828C265.1 152.959 257.289 158.174 257.289 158.174C257.289 158.174 262.87 156.621 264.133 159.358C265.395 162.094 256.3 162.244 256.3 162.244L221.22 162.249Z",
    fill: "#91882A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.962 162.249C225.962 162.249 226.285 147.395 231.868 147.821C237.452 148.246 229.653 162.249 229.653 162.249H225.962Z",
    fill: "#CBC253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.962 162.249C225.962 162.249 220.356 148.222 212.752 151.822C205.328 155.329 221.304 162.249 221.304 162.249H225.962Z",
    fill: "#CBC253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.496 162.249C237.496 162.249 242.529 149.62 250.514 150.821C258.5 152.022 240.671 162.249 240.671 162.249H237.496Z",
    fill: "#CBC253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.708 162.249C245.708 162.249 261.327 154.374 264.14 159.126C266.953 163.878 245.708 162.249 245.708 162.249Z",
    fill: "#CBC253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5726 63.0723H60.1777V143.216H81.5726V63.0723Z",
    fill: "white",
    stroke: "#96BED5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7903 90.6082H65.959V93.1356H75.7903V90.6082Z",
    fill: "#96BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7903 97.3708H65.959V99.8983H75.7903V97.3708Z",
    fill: "#96BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7903 104.134H65.959V106.661H75.7903V104.134Z",
    fill: "#96BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7903 110.899H65.959V113.426H75.7903V110.899Z",
    fill: "#96BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8756 134.207C73.5431 134.207 75.7061 132.044 75.7061 129.376C75.7061 126.708 73.5431 124.545 70.8756 124.545C68.2077 124.545 66.0449 126.708 66.0449 129.376C66.0449 132.044 68.2077 134.207 70.8756 134.207Z",
    fill: "#96BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.845 63.0723H83.4512V143.216H104.845V63.0723Z",
    fill: "white",
    stroke: "#6869E1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0654 90.6082H89.2344V93.1356H99.0654V90.6082Z",
    fill: "#6869E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0654 97.3708H89.2344V99.8983H99.0654V97.3708Z",
    fill: "#6869E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0654 104.134H89.2344V106.661H99.0654V104.134Z",
    fill: "#6869E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0654 110.899H89.2344V113.426H99.0654V110.899Z",
    fill: "#6869E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1484 134.207C96.8164 134.207 98.9794 132.044 98.9794 129.376C98.9794 126.708 96.8164 124.545 94.1484 124.545C91.4804 124.545 89.3174 126.708 89.3174 129.376C89.3174 132.044 91.4804 134.207 94.1484 134.207Z",
    fill: "#6869E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.12 63.0723H106.726V143.216H128.12V63.0723Z",
    fill: "#E7F0FD",
    stroke: "#96BED5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.337 90.2686H112.506V92.796H122.337V90.2686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.337 97.0312H112.506V99.5587H122.337V97.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.337 103.794H112.506V106.321H122.337V103.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.337 110.559H112.506V113.087H122.337V110.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.423 133.867C120.091 133.867 122.254 131.704 122.254 129.036C122.254 126.368 120.091 124.205 117.423 124.205C114.755 124.205 112.592 126.368 112.592 129.036C112.592 131.704 114.755 133.867 117.423 133.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.393 63.0723H129.998V143.216H151.393V63.0723Z",
    fill: "white",
    stroke: "#4849FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.612 90.6082H135.781V93.1356H145.612V90.6082Z",
    fill: "#4849FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.612 97.3708H135.781V99.8983H145.612V97.3708Z",
    fill: "#4849FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.612 104.134H135.781V106.661H145.612V104.134Z",
    fill: "#4849FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.612 110.899H135.781V113.426H145.612V110.899Z",
    fill: "#4849FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.695 134.207C143.363 134.207 145.526 132.044 145.526 129.376C145.526 126.708 143.363 124.545 140.695 124.545C138.028 124.545 135.865 126.708 135.865 129.376C135.865 132.044 138.028 134.207 140.695 134.207Z",
    fill: "#4849FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 670,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/login-image.9bb7a67e309ea53455c72e1c773f2084.svg";
export { ForwardRef as ReactComponent };